import React from 'react';
import { Input as ReactstrapInput, FormFeedback, Label } from 'reactstrap';
import { format, parseISO } from 'date-fns';
import Info from './Info';

const DateInput = ({
  label,
  name,
  error,
  value,
  tooltip,
  disabled,
  onChange,
  ...props
}) => {
  const toInputValue = date => {
    if (!date) return '';
    const parsed = date instanceof Date ? date : parseISO(String(date));
    return isNaN(parsed) ? '' : format(parsed, 'yyyy-MM-dd');
  };

  return (
    <>
      {label && (
        <Label for={name}>
          {label}
          {tooltip && (
            <>
              {' '}
              <Info id={`tooltip${name}`} tooltip={tooltip ?? ''} />
            </>
          )}
        </Label>
      )}
      <ReactstrapInput
        type="date"
        id={name}
        name={name}
        value={toInputValue(value)}
        disabled={disabled}
        invalid={!!error}
        onChange={e =>
          onChange?.(e.target.value ? parseISO(e.target.value) : null)
        }
        {...props}
      />
      {error && <FormFeedback>{error}</FormFeedback>}
    </>
  );
};

export default DateInput;
